import { useEffect, useState } from "react";
import { Content, SubContent, Main } from "../../../components/Layout";
import style from "../style.module.css";
import MenuTrainee from "../../../components/MenuTrainee";
import { Row, Col } from "react-bootstrap";
import api from "../../../services/api";
import useWrapper from "../../../hooks/useWrapper";
import TableResponsive from "../../../components/TableResponsive";
import useFormat from "../../../hooks/utils/useFormat";
import StatusFlag from "../../../components/StatusFlag";
import { toast } from "react-toastify";
import MeusDadosIco from "../../../components/Svg/new/meus-dados";
import { formatTrainee } from "../../../hooks/api/listTrainees";

export default function Formandos() {
  const { me, config } = useWrapper();
  const { formatPhone } = useFormat();

  const [loading, setloading] = useState();
  const [trainees, settrainees] = useState();
  useEffect(() => {
    if (me && !trainees) {
      (async () => {
        setloading(true);

        try {
          const { data: _trainees } = await api.get(
            `/trainee/trainees?joins=null&commercial_id=${me?.commercial_id}&paginate=false`,
            config,
          );

          // formatTrainee é a fonte única dos rótulos de Vínculo; antes esta
          // tela tinha uma cópia própria da regra, que já havia ficado para
          // trás (não conhecia distrato) e mostrava status errado ao formando
          settrainees(_trainees?.map(__trainee => formatTrainee(__trainee)));
        } catch (__err) {
          toast.error("Ocorreu algum problema ao tentar carregar a Lista de Formandos.");
          console.log("__err", __err);
        }
        setloading(false);
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- `config` is a new object every WrapperProvider render (src/context/WrapperContext.jsx); adding it would refire this fetch on unrelated context updates.
  }, [me, trainees]);

  return (
    <Main className={style.mainUser}>
      <Content noBG="true">
        <Row>
          <Col md={12} lg={2}>
            <MenuTrainee />
          </Col>
          <Col>
            <SubContent>
              <h2 className="form-title mb-4">Lista de Formandos</h2>
              <TableResponsive
                table={{
                  head: [
                    { data: "Formando" },
                    { data: "Contato" },
                    { data: <div className="text-end">Financeiro</div> },
                    { data: <div className="text-end">Vínculo</div> },
                  ],
                  loading: loading,
                  body:
                    trainees?.map(__trainee => ({
                      disabled: !!__trainee?.cancel,
                      data: [
                        {
                          element: (
                            <>
                              {__trainee.is_member ? (
                                <span className="smaller-ico">
                                  <MeusDadosIco />
                                </span>
                              ) : (
                                ""
                              )}
                              {__trainee.name}
                            </>
                          ),
                        },
                        {
                          element: (
                            <>
                              <p className="m-0">{__trainee.email}</p>
                              <p className="m-0">{formatPhone(__trainee.cell)}</p>
                            </>
                          ),
                        },
                        {
                          element: (
                            <div className="text-end">
                              <StatusFlag status={!__trainee?.financial_released ? "Sem Financeiro" : "Criado"} />
                            </div>
                          ),
                        },
                        {
                          element: (
                            <div className="text-end">
                              <StatusFlag status={__trainee?.bond || "?"} tone={__trainee?.bond_tone}>
                                {__trainee?.bond_short || __trainee?.bond || "?"}
                              </StatusFlag>
                            </div>
                          ),
                        },
                      ],
                    })) || [],
                }}
              />
            </SubContent>
          </Col>
        </Row>
      </Content>
    </Main>
  );
}
